import {
    formatJobType,
} from "@mrflark/core/utils";

export type NumericSettingConfig = {
    type?: "number";
    key: string;
    label: string;
    min: number;
    max: number;
    step: number;
    defaultValue: string;
    formatValue?: (value: number) => string;
    group?: string;
};

export type TextSettingConfig = {
    type: "text" | "textarea";
    key: string;
    label: string;
    defaultValue: string;
    placeholder?: string;
    group?: string;
};

export type BooleanSettingConfig = {
    type: "boolean";
    key: string;
    label: string;
    defaultValue: string;
    group?: string;
};

export type SelectOption = {
    value: string;
    label: string;
};

export type SelectSettingConfig = {
    type: "select";
    key: string;
    label: string;
    defaultValue: string;
    options: SelectOption[];
    group?: string;
};

export type SettingConfig =
    | NumericSettingConfig
    | TextSettingConfig
    | BooleanSettingConfig
    | SelectSettingConfig;

export type TimePeriodOption = {
    label: string;
    minutes: number;
};

export const DEFAULT_TIME_PERIODS: TimePeriodOption[] = [
    {
        label: "15m",
        minutes: 15,
    },
    {
        label: "1h",
        minutes: 60,
    },
    {
        label: "6h",
        minutes: 360,
    },
    {
        label: "24h",
        minutes: 1440,
    },
    {
        label: "All",
        minutes: 0,
    },
];

export const DEFAULT_STATUS_OPTIONS = [
    "pending",
    "processing",
    "completed",
    "failed",
    "cancelled",
];

export const PAGE_SIZE_OPTIONS = [10, 25, 50];

export type StreamIntervalOption = {
    label: string;
    ms: number;
};

export const STREAM_INTERVAL_OPTIONS: StreamIntervalOption[] = [
    {
        label: "1s",
        ms: 1000,
    },
    {
        label: "5s",
        ms: 5000,
    },
    {
        label: "10s",
        ms: 10000,
    },
    {
        label: "30s",
        ms: 30000,
    },
];

export const getJobTypeLabel = (
    jobType: string,
    labels?: Record<string, string>,
): string => {
    return labels?.[jobType] ?? formatJobType(jobType);
};
